'use strict';
var urlCapAddressSearchEmail = $("#url-cap-email-search-email").val();

/**
 * @function SearchMailCivWS call AJAX for CAPAddress-SearchMailCivWS
 * @param {steep}
 * @param {zipCode}
*/

async function SearchMailCivWS(email,fname,lname) {
    var capEmailData = {
        sInput: email,
        sNom: fname,
        sPrenom: lname
    };

    return new Promise((resolve, reject) => {
        $.ajax({
            url: urlCapAddressSearchEmail,
            type: 'get',
            data: capEmailData,
            dataType: 'json',
            success: function (data) {
                resolve(data);
            },
            error: function (err) {
                reject(err);
            }
        });
    })
}

module.exports = {
    SearchMailCivWS: SearchMailCivWS
}